import { render, staticRenderFns } from "./ConfirmDistribute.vue?vue&type=template&id=735df7b2"
import script from "./ConfirmDistribute.vue?vue&type=script&lang=js"
export * from "./ConfirmDistribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports